import { CommanderThunkAction } from '@mews-commander/types';
import { getTravelAgencyContractId } from '@mews-commander/legacy-entities/src/ducks/travelAgencyContracts';
import { openCustomerDetail, openCustomerInternals } from '../../app/actions/customer';
import { openCompanyDetail } from '../../app/actions/companies';
import { openTravelAgencyContractDetail } from '../../app/actions/travelAgencyContracts';
import { trackReservationModuleEvent } from './tracking';

interface ProfileAction {
    accountId: string;
}

interface EditCompanyAction {
    id: string;
    onClose?: () => void;
}

export const editProfile =
    ({ accountId }: ProfileAction): CommanderThunkAction =>
    (dispatch) => {
        dispatch(trackReservationModuleEvent({ eventAction: 'openCustomerProfile' }));
        return dispatch(openCustomerDetail(accountId));
    };

export const editInternal =
    ({ accountId }: ProfileAction): CommanderThunkAction =>
    (dispatch) => {
        dispatch(trackReservationModuleEvent({ eventAction: 'openCustomerInternals' }));
        return dispatch(openCustomerInternals(accountId));
    };

export const editCompany =
    ({ id }: EditCompanyAction): CommanderThunkAction =>
    (dispatch) => {
        dispatch(trackReservationModuleEvent({ eventAction: 'openCompanyDetail' }));
        return dispatch(openCompanyDetail(id));
    };

export const editTravelAgencyContract =
    ({ id }: { id: string; onClose?: () => void }): CommanderThunkAction =>
    (dispatch, getState) => {
        const contractId = getTravelAgencyContractId(getState(), { companyId: id });
        if (contractId) {
            dispatch(trackReservationModuleEvent({ eventAction: 'openTravelAgencyDetail' }));
            return dispatch(openTravelAgencyContractDetail(contractId));
        }
    };
